import script from "./form-drawer-2.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-drawer-2.vue?vue&type=script&lang=ts&setup=true"

import "./form-drawer-2.vue?vue&type=style&index=0&id=390fbda7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390fbda7"]])

export default __exports__